import client from "../client";

export interface SendMessageRequest {
  prefix: string;
  username: string;
  text: string;
}

export default function API(request: SendMessageRequest) {
  return client
    .post(`chat/send_image`, request)
    .then((response) => response.data);
}
